module.exports = __webpack_public_path__ + "img/logoHeader.74ebaa8f.png";